import React from 'react';
import {Link} from 'react-router-dom';
import {ArrowLeftOutlined} from '@ant-design/icons';

import Table from '../../components/ui/Table';
import {dealsTableConfig} from './configs/dealsTableConfig';
import {missionsTableConfig} from './configs/missionsTableConfig';

const PilotedDealsPage = ({
    data,
    handleMissionNavigation,
    filterDealList,
    userData,
    tableType,
    paginationMetadata,
    onPageNumberChange,
    tableLoading
}) => {
    const tableConfig = dealsTableConfig(handleMissionNavigation, filterDealList, userData, tableType);
    const missionsConfig = missionsTableConfig();

    return (
        <>
            <div className='flex items-center justify-between pt-10 pb-5'>
                <Link to='/dashboard/consultant'>
                    <ArrowLeftOutlined style={{fontSize: '25px'}}/>
                </Link>
                <h1
                    className='text-3xl font-bold'
                    style={{fontFamily: 'DIN Condensed'}}
                >
                    {`Affaires pilotées (${paginationMetadata.totalItems})`}
                </h1>
                <div/>
            </div>
            <Table
                data={data}
                tableConfig={tableConfig}
                paginationMetadata={paginationMetadata}
                dropdownConfig={missionsConfig}
                onPageNumberChange={onPageNumberChange}
                dropdownChildrenKey='missions'
                loading={tableLoading}
            />
        </>
    )
}

export default PilotedDealsPage;
